module.exports = __webpack_public_path__ + "static/img/icon_signin_nosex.02e56914.svg";